module.exports = __webpack_public_path__ + "static/media/developerActivity.94c240e6.svg";